//#region IMPORTAÇÕES
import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { EcomerceService } from "../../services/ecommerce.service";
import { Router } from "@angular/router";
//#endregion

@Component({
  selector: "app-location-picker",
  templateUrl: "./location-picker.component.html",
  styleUrls: [],
})
export class LocationPickerComponent implements OnInit {
  cidades: any;
  cidade = null;
  erro: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private ecomerceService: EcomerceService,
    public toastrService: ToastrService,
    private router: Router
  ) {}

  ngOnInit() {
    if (localStorage.getItem("linkDireto") === "true") {
      this.activeModal.dismiss();
    } else {
      this.listarCidades();
    }
  }

  listarCidades() {
    this.ecomerceService.listarCidades().subscribe((data) => {
      this.cidades = data;
    });
  }

  selecionar() {
    this.erro = false;
    if (this.cidade === null || this.cidade === undefined) {
      this.erro = true;
    } else {
      localStorage.setItem("location", this.cidade);
      localStorage.removeItem("linkDireto");
      this.activeModal.close(this.cidade);
    }
  }
}
